//根据事件名称修改数据库


import * as types from './mutation_types.js'

const mutations = {
  [types.SENDselectaddress](state, selectaddress) {
    state.selectaddress = selectaddress;
  },
  [types.SENDcoupon](state, coupon) {
    state.coupon = coupon;
  },
  [types.SENDAreaCoupon](state, areaCoupon) {
    state.areaCoupon = areaCoupon;
  },
  [types.SENDpayment](state, payment) {
    state.payment = payment;
  },
  [types.SENDuserInfo](state, userInfo) {
    state.userInfo = userInfo;
  },
  [types.SENDagentText](state, agentText) {
    state.agentText = agentText;
  },
  [types.SENDdirectorText](state, directorText) {
    state.directorText = directorText;
  },
  [types.SENDreceive](state, receive) {
    state.receive = receive;
  },
}

export default mutations;






// WEBPACK FOOTER //
// ./src/store/mutations.js